/**
 * Match scene objects to persisted physics entries (objectId may be name, _id, url, etc.).
 */
export function getObjectPhysicsIds(object) {
  if (!object) return [];

  return [
    object.name,
    object._id,
    object.url,
    object.file_name,
    object.temp_file_name,
    object.userData?.id,
    object.userData?._id,
    object.userData?.temp_file_name,
  ].filter(Boolean);
}

export function findPhysicsDataForObject(object, physicsObjects) {
  if (!object || !Array.isArray(physicsObjects) || physicsObjects.length === 0) {
    return null;
  }

  const ids = getObjectPhysicsIds(object);
  if (!ids.length) return null;

  return (
    physicsObjects.find((entry) => ids.includes(entry.objectId)) || null
  );
}

export function objectHasPhysicsData(object, physicsObjects) {
  return !!findPhysicsDataForObject(object, physicsObjects);
}

export function getPhysicsObjectId(object, physicsObjects) {
  const entry = findPhysicsDataForObject(object, physicsObjects);
  return entry?.objectId || object?.name || null;
}
